// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {Event, ISimSession, SessionType} from "@models";
import {NgTemplateOutlet} from "@angular/common";
import {PeerPracticeSessionCardComponent} from "@common/components/session/session-card/session-type/peer-practice/peer-practice-session-card.component";
import {ExamSessionCardComponent} from "@common/components/session/session-card/session-type/exam/exam-session-card.component";
import {NonSimulationSessionCardComponent} from "@common/components/session/session-card/session-type/non-simulation/non-simulation-session-card.component";
import {TeamTrainingSessionCardComponent} from "@common/components/session/session-card/session-type/team-training/team-training-session-card.component";
import {GeneratedTypePredicates} from "@services";
import {MultiRoomRecordingSessionCardComponent} from "@common/components/session/session-card/session-type/multi-room-recording-session-card/multi-room-recording-session-card.component";
import {AutomaticRecordingSessionCardComponent} from "@common/components/session/session-card/session-type/automatic-recording/automatic-recording-session-card.component";

@Component({
	selector: "sim-session-card",
	templateUrl: "./session-card.component.html",
	styleUrls: ["./session-card.component.scss"],
	imports: [
		PeerPracticeSessionCardComponent,
		ExamSessionCardComponent,
		NonSimulationSessionCardComponent,
		TeamTrainingSessionCardComponent,
		NgTemplateOutlet,
		MultiRoomRecordingSessionCardComponent,
		AutomaticRecordingSessionCardComponent,
	],
})
export class SessionCardComponent {
	SessionType = SessionType;
	GeneratedTypePredicates = GeneratedTypePredicates;

	@Input() session: ISimSession;
	@Input() creationMode: boolean = false;
	@Input() showRecordingExports: boolean = false;
	@Input() event: Event;
	@Input() hideDraftSessions: boolean;
	@Input() showOnlyRecordedScenarios: boolean;

	@Input() showLoadingSpinnerOnScheduledSession: boolean = false;
	@Input() usedWithinEventSelection: boolean = false;

	@Input() showRemoveAction: boolean = false;
	@Input() showEditAction: boolean = false;
	@Input() showJoinStartActions: boolean = false;
	@Input() finishedRunsClickable: boolean = false;
	@Input() showActionMenu: boolean = false;

	@Input() sessionStartable: boolean = false;
	@Input() isArchive: boolean = false;
	@Input() isExamSchedule: boolean = false;

	finishedRunClickedEmitter = output<string>();
	edit = output<void>();
	delete = output<void>();
}
